import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import AnexoUnicoPanel, { getFormData } from "components/anexo/AnexoUnicoPanel";
import { Label } from "components/input/Label";
import ModalDocumentoReprovar from "components/modal/documentos/ModalDocumentoReprovar";
import ModalDocumentoVisualizarArquivo from "components/modal/documentos/ModalDocumentoVisualizarArquivo";
import dayjs from "dayjs";
import saveAs from 'file-saver';
import Usuario from "model/administracao/cadastro/Usuario";
import Arquivo from "model/arquivo/Arquivo";
import DocumentoVersao from "model/documentos/DocumentoVersao";
import DocumentoVersaoInteressado from "model/documentos/DocumentoVersaoInteressado";
import DocumentoVersaoNecessidadeConfirmacao from "model/documentos/DocumentoVersaoNecessidadeConfirmacao";
import FinalizarAprovacao from "model/documentos/fluxo/FinalizarAprovacao";
import FinalizarElaboracao from "model/documentos/fluxo/FinalizarElaboracao";
import FinalizarRevisao from "model/documentos/fluxo/FinalizarRevisao";
import PublicarVersao from "model/documentos/fluxo/PublicarVersao";
import UsuarioLogado from "model/usuario/UsuarioLogado";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Column, ColumnBodyOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { TabPanel, TabView } from "primereact/tabview";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useRef, useState } from "react";
import "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import ContaService from "service/administracao/cadastro/ContaService";
import DocumentoVersaoService from "service/documentos/DocumentoVersaoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { usuarioCompleteMethod, usuarioItemTemplate } from "utils/autocompleteUtils";
import { converterDataHora } from "utils/convert";

const documentoVersaoService = new DocumentoVersaoService();
const contaService = new ContaService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function DocumentoFluxoPage() {


    const [queryParameters] = useSearchParams();
    const navigate = useNavigate();
    const { control, setFocus, clearErrors, setError, register, formState: { errors } } = useForm();

    const { startLoading, stopLoading } = useLoadingContext();

    const { msgAlerta, msgSucesso, msgErro } = useToastContext();

    const inputNomeRef = useRef<any>(null);

    const [documentoVersao, setDocumentoVersao] = useState<DocumentoVersao>(new DocumentoVersao());
    const [dadosElaboracao, setDadosElaboracao] = useState<FinalizarElaboracao>(new FinalizarElaboracao());
    const [dadosRevisao, setDadosRevisao] = useState<FinalizarRevisao>(new FinalizarRevisao());
    const [dadosAprovacao, setDadosAprovacao] = useState<FinalizarAprovacao>(new FinalizarAprovacao());
    const [dadosPublicarVersao, setDadosPublicarVersao] = useState<PublicarVersao>(new PublicarVersao());

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([]);
    const [anexo, setAnexo] = useState<any>();
    const [visibleInteressados, setVisibleInteressados] = useState<boolean>();
    const [visibleLeitores, setVisibleLeitores] = useState<boolean>();
    const [tabIndex, setTabIndex] = useState<number>(0);
    const [documentoVisualizar, setDocumentoVisualizar] = useState<{ visible: boolean, arquivo: Arquivo | null }>({ visible: false, arquivo: null });
    const [visibleModalDocumentoReprovar, setVisibleModalDocumentoReprovar] = useState<boolean>(false);

    const [usuarioLogado, setUsuarioLogado] = useState<UsuarioLogado>(usuarioLogadoService.getUsuario());

    useEffect(() => {
        if (documentoVersao?.status) {
            switch (documentoVersao.status) {
                case "EM_ELABORACAO":
                    setTabIndex(0);
                    break;
                case "EM_REVISAO":
                    setTabIndex(1);
                    break;
                case "AGUARDANDO_APROVACAO":
                    setTabIndex(2);
                    break;
                case "AGUARDANDO_PUBLICACAO":
                    setTabIndex(3);
                    break;
                case "PUBLICADO":
                    setTabIndex(4);
                    break;
                default:
                    setTabIndex(0);
            }
        }
    }, [documentoVersao.status]);

    useEffect(() => {
        documentoVersaoService.usuarios().then(json => {
            setUsuarios([new Usuario(0, null, "Selecione um usuário"), ...json]);
        }).catch(e => {
            console.error(e);
        });
    }, []);

    function carregarDadosFluxo(versao: DocumentoVersao) {
        startLoading();
        const idDocumentoVersao = window.location.pathname.substring(`/documentoVersao/editar/`.length);

        documentoVersaoService.getDadosFluxo(idDocumentoVersao).then(data => {
            stopLoading();
            if (versao.status === "EM_ELABORACAO") {
                if (!data.dadosElaboracao.responsavelAprovacao) {
                    data.dadosElaboracao.responsavelAprovacao = versao.documento?.categoria.aprovadorPadrao || null;
                }
                if (!data.dadosElaboracao.responsavelRevisao) {
                    data.dadosElaboracao.responsavelRevisao = versao.documento?.categoria.revisorPadrao || null;
                }
            }
            setDadosElaboracao(data.dadosElaboracao);
            setDadosRevisao(data.dadosRevisao);
            setDadosAprovacao(data.dadosAprovacao);
            setDadosPublicarVersao(data.dadosPublicacao);
        }).catch(err => {
            stopLoading();
            console.error(err);
        })
    }

    const consultar = () => {
        setAnexo(null);
        carregarDadosFluxo(documentoVersao);
        documentoVersaoService.consultar(documentoVersao.id)
            .then((data: DocumentoVersao) => {
                setDocumentoVersao(data);
            }).catch((e) => console.error(e));
    }

    const finalizarElaboracao = () => {
        if (validarElaboracao()) {
            startLoading();
            const finalizarElaboracaoLocal = {
                ...dadosElaboracao,
                idVersao: documentoVersao.id,
            };

            documentoVersaoService.finalizarElaboracao(getFormData("finalizarElaboracao", finalizarElaboracaoLocal, anexo)).then((data) => {
                consultar();
                if (usuarioLogado.id !== finalizarElaboracaoLocal.responsavelRevisao?.id) {
                    navigate(-1);
                    msgSucesso("Fluxo de Documento", "Documento enviado para revisão com sucesso!");
                } else {
                    setTabIndex(1);
                }
            }).catch((e) => {
                msgAlerta("Alerta", e?.data?.message || "");
                console.error(e);
            }).finally(() => {
                stopLoading();
            });
        }
    }

    function validarElaboracao() {
        if (dadosElaboracao.versaoInicial !== 0 && !dadosElaboracao.versaoInicial) {
            setError("versaoInicial", { type: "manual", message: "Versão Inicial é Obrigatória" }, { shouldFocus: true })
            return false;
        }
        if (!dadosElaboracao.responsavelRevisao) {
            setError("responsavelRevisao", { type: "manual", message: "Responsável Revisão é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!dadosElaboracao.prazoRevisao) {
            setError("prazoRevisao", { type: "manual", message: "Prazo para revisão é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (documentoVersao.temAprovacao) {
            if (!dadosElaboracao.responsavelAprovacao) {
                setError("responsavelAprovacao", { type: "manual", message: "Responsável Aprovação é Obrigatório" }, { shouldFocus: true })
                return false;
            }
            if (!dadosElaboracao.prazoAprovacao) {
                setError("prazoAprovacao", { type: "manual", message: "Prazo para aprovação é Obrigatório" }, { shouldFocus: true })
                return false;
            }
        }
        if (!anexo && !documentoVersao.arquivo && !documentoVersao.linkDocs) {
            setError("anexos", { type: "manual", message: "Anexar o documento é Obrigatório" }, { shouldFocus: true })
            msgAlerta("Anexos", "Anexar o documento é Obrigatório");
            return false;
        }
        return true;
    }

    const finalizarRevisao = () => {
        if (validarRevisao()) {
            startLoading();
            const finalizarRevisaoLocal = {
                ...dadosRevisao,
                idVersao: documentoVersao.id,
            };

            documentoVersaoService.finalizarRevisao(getFormData("finalizarRevisao", finalizarRevisaoLocal, anexo)).then(() => {
                consultar();
                if (documentoVersao.temAprovacao && usuarioLogado.id !== documentoVersao.usuarioAprovacao?.id ||
                    !documentoVersao.temAprovacao && usuarioLogado.id !== documentoVersao.usuarioRevisao?.id
                ) {
                    navigate(-1);
                    msgSucesso("Fluxo de Documento", "Revisão finalizada com sucesso!");
                } else {
                    setTabIndex(2);
                }
            }).catch((e) => {
                msgAlerta("Alerta", e?.data?.message || "");
                console.error(e);
                if (e.message) {
                    msgAlerta("Fluxo de Documento", e.message)
                } else {
                    msgErro("Fluxo de Documento", "Ocorreu um erro ao finalizar revisão")
                }

            }).finally(() => {
                stopLoading();
            });
        }
    }

    function validarRevisao() {
        if (dadosRevisao.versao !== 0 && !dadosRevisao.versao) {
            setError("versaoInicial", { type: "manual", message: "Versão é Obrigatória" }, { shouldFocus: true })
            return false;
        }
        if (!anexo && !documentoVersao.arquivo && !documentoVersao.linkDocs) {
            setError("anexos", { type: "manual", message: "Anexar o documento é Obrigatório" }, { shouldFocus: true })
            msgAlerta("Anexos", "Anexar o documento é Obrigatório");
            return false;
        }
        return true;
    }

    const finalizarAprovacao = (aprovado: boolean) => {
        const finalizarAprovacaoLocal = {
            ...dadosAprovacao,
            aprovado: aprovado,
            idVersao: documentoVersao.id
        };
        startLoading();
        documentoVersaoService.finalizarAprovacao(finalizarAprovacaoLocal).then(() => {
            consultar();
            if (aprovado) {
                setTabIndex(3);
            } else {
                if (usuarioLogado.id !== documentoVersao.usuarioRevisao?.id) {
                    navigate(-1);
                    msgSucesso("Fluxo de Documento", "Documento reenviado para revisão!");
                } else {
                    setTabIndex(1);
                }
            }
        }).catch((e) => {
            msgAlerta("Alerta", e?.data?.message || "");
            console.error(e);
            if (e.message) {
                msgAlerta("Fluxo de Documento", e.message)
            } else {
                msgErro("Fluxo de Documento", "Ocorreu um erro ao enviar para publicação")
            }
        }).finally(() => {
            stopLoading();
        });

    }

    const publicar = () => {
        const publicarVersaoLocal = {
            ...dadosPublicarVersao,
            idVersao: documentoVersao.id
        };

        startLoading();

        documentoVersaoService.publicarVersao(publicarVersaoLocal).then(() => {
            consultar();
            setTabIndex(4);
        }).catch((e) => {
            msgAlerta("Alerta", e?.data?.message || "");
            console.error(e);
        }).finally(() => {
            stopLoading();
        });

    }

    const editorInteressados = (rowData: DocumentoVersaoInteressado, rowIndex: number) => {

        return <Dropdown
            className="col col-sm-12"
            options={usuarios}
            filter
            dataKey="id"
            optionLabel="nome"
            valueTemplate={(option: Usuario) => option ? option.nome : "Selecione"}
            value={rowData.usuario || usuarios[0]}
            style={{ width: '100%' }}
            onChange={(e) => {
                if (e.value.id === -1) {
                    dadosPublicarVersao.interessados[rowIndex].usuario = null;
                    rowData.usuario = null;
                }
                else {
                    dadosPublicarVersao.interessados[rowIndex].usuario = e.value as Usuario;
                    rowData.usuario = e.value as Usuario;
                }
                setDadosPublicarVersao({ ...dadosPublicarVersao })
            }}
        />
    }

    const editorLeitores = (rowData: DocumentoVersaoNecessidadeConfirmacao, rowIndex: number) => {
        return <Dropdown
            className="col col-sm-12"
            options={usuarios}
            filter
            dataKey="id"
            optionLabel="nome"
            valueTemplate={(option: Usuario) => option ? option.nome : "Selecione"}
            value={rowData.usuario || usuarios[0]}
            style={{ width: '100%' }}
            onChange={(e) => {
                if (e.value.id === -1) {
                    dadosPublicarVersao.necessidadesConfirmacao[rowIndex].usuario = null;
                    rowData.usuario = null;
                }
                else {
                    dadosPublicarVersao.necessidadesConfirmacao[rowIndex].usuario = e.value as Usuario;
                    rowData.usuario = e.value as Usuario;
                }
                setDadosPublicarVersao({ ...dadosPublicarVersao })
            }}
        />
    }

    const BarraDeProgresso = () => {
        const statusList = documentoVersaoService.statuses();
        const statusAtual = documentoVersao.status;
        const statusIndex = statusList.findIndex(s => s.value === statusAtual);

        return (
            <div className="d-flex justify-content-between align-items-center px-3 py-3 rounded mb-4" style={{ gap: "12px" }}>
                {statusList.map((etapa, index) => {
                    const isConcluido = index < statusIndex;
                    const isAtual = index === statusIndex;
                    if (etapa.value === "AGUARDANDO_APROVACAO" && !documentoVersao.temAprovacao) {
                        return <></>
                    }
                    return (
                        <div key={etapa.value} className="text-center" style={{ flex: 1 }}>
                            <div
                                style={{
                                    height: "20px",
                                    borderRadius: "9999px",
                                    backgroundColor: isAtual
                                        ? "#240E92"
                                        : isConcluido
                                            ? "#28a745"
                                            : "#ccc",
                                    marginBottom: "4px",
                                }}
                            />
                            <small
                                style={{
                                    color: isAtual
                                        ? "#240E92"
                                        : isConcluido
                                            ? "#28a745"
                                            : "#aaa",
                                    fontWeight: isAtual ? "bold" : "normal",
                                }}
                            >
                                {etapa.label}
                            </small>
                        </div>
                    );
                })}
            </div>
        );
    };

    const elaborando = documentoVersao.status === "EM_ELABORACAO";
    const revisando = documentoVersao.status === "EM_REVISAO";
    const aprovando = documentoVersao.status === "AGUARDANDO_APROVACAO";
    const publicando = documentoVersao.status === "AGUARDANDO_PUBLICACAO";


    return (

        <BaseCadastro model={documentoVersao} service={documentoVersaoService} setModel={(value: DocumentoVersao) => setDocumentoVersao(value)} afterLoad={(versao: DocumentoVersao) => carregarDadosFluxo(versao)}
            validar={() => true} urlService="/documentoVersao" pathCadastro="/documentoVersao" tituloPagina={'Documento Fluxo'} showGravarButton={false}>

            {documentoVisualizar.visible ? <ModalDocumentoVisualizarArquivo
                visible={documentoVisualizar.visible}
                onHide={() => setDocumentoVisualizar({ visible: false, arquivo: null })}
                arquivo={documentoVisualizar.arquivo as Arquivo}
            /> : null}
            {visibleModalDocumentoReprovar ? <ModalDocumentoReprovar
                visible={visibleModalDocumentoReprovar}
                onHide={() => setVisibleModalDocumentoReprovar(false)}
                value={dadosAprovacao}
                onChange={(value: FinalizarAprovacao) => setDadosAprovacao(value)}
                onConfirm={() => {
                    finalizarAprovacao(false);
                    setVisibleModalDocumentoReprovar(false);
                }}
            />
                : null}
            {visibleInteressados ?
                <Dialog header="Interessados" visible={visibleInteressados} style={{ width: '80vw' }} onHide={() => setVisibleInteressados(false)}>
                    <div className="row">
                        <div className="col col-sm-12">
                            <DataTable emptyMessage="Nenhum interessado encontrado" value={dadosPublicarVersao.interessados} scrollable scrollHeight='500px'
                                header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                                    <div></div>
                                    <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Usuários</span>
                                    <div>
                                        <Button
                                            type="button" icon={<FontAwesomeIcon icon="add" />}
                                            tooltip="Adicionar"
                                            tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => setDadosPublicarVersao({ ...dadosPublicarVersao, interessados: [...(dadosPublicarVersao.interessados || []), new DocumentoVersaoInteressado()] })}
                                        ></Button>
                                    </div>
                                </div>}
                            >
                                <Column
                                    field="usuario" header="Usuário"
                                    body={(rowData: DocumentoVersaoInteressado, options: ColumnBodyOptions) => editorInteressados(rowData, options.rowIndex)}
                                />
                                <Column
                                    header="Ações"
                                    body={rowData => (
                                        <Button
                                            icon={<FontAwesomeIcon icon="trash" />}
                                            className="p-button-danger p-button-sm"
                                            onClick={() =>
                                                setDadosPublicarVersao({
                                                    ...dadosPublicarVersao,
                                                    interessados: dadosPublicarVersao.interessados.filter(i => i !== rowData),
                                                })
                                            }
                                        />
                                    )}
                                    style={{ width: 80, textAlign: 'center' }}
                                />
                            </DataTable>
                        </div>
                    </div>
                </Dialog>
                : null}
            {visibleLeitores ?
                <Dialog header="Leitores" visible={visibleLeitores} style={{ width: '80vw' }} onHide={() => setVisibleLeitores(false)}>
                    <div className="row">
                        <div className="col col-sm-12">
                            <DataTable emptyMessage="Nenhum resultado encontrado" value={dadosPublicarVersao.necessidadesConfirmacao} scrollable scrollHeight='500px'
                                header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                                    <div></div>
                                    <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Usuários</span>
                                    <div>
                                        <Button
                                            type="button" icon={<FontAwesomeIcon icon="add" />}
                                            tooltip="Adicionar"
                                            tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => setDadosPublicarVersao({ ...dadosPublicarVersao, necessidadesConfirmacao: [...(dadosPublicarVersao.necessidadesConfirmacao || []), new DocumentoVersaoNecessidadeConfirmacao()] })}
                                        ></Button>
                                    </div>
                                </div>}
                            >
                                <Column
                                    field="usuario" header="Usuário"
                                    body={(rowData: DocumentoVersaoNecessidadeConfirmacao, options: ColumnBodyOptions) => editorLeitores(rowData, options.rowIndex)}
                                />
                                <Column
                                    header="Ações"
                                    body={rowData => (
                                        <Button
                                            icon={<FontAwesomeIcon icon="trash" />}
                                            className="p-button-danger p-button-sm"
                                            onClick={() =>
                                                setDadosPublicarVersao({
                                                    ...dadosPublicarVersao,
                                                    interessados: dadosPublicarVersao.interessados.filter(i => i !== rowData),
                                                })
                                            }
                                        />
                                    )}
                                    style={{ width: 80, textAlign: 'center' }}
                                />
                            </DataTable>
                        </div>
                    </div>
                </Dialog>
                : null}
            <BarraDeProgresso />
            <TabView activeIndex={tabIndex} onTabChange={(e) => setTabIndex(e.index)}>
                <TabPanel header="Elaboração">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Responsável</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.usuarioResponsavel?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Código</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.codigoInterno} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Nome</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" obrigatorio>Versão Inicial</Label>
                                <div className="col-sm-12">
                                    <Controller name="versaoInicial" control={control} render={({ field }) => (
                                        <InputNumber value={dadosElaboracao.versaoInicial}
                                            disabled={!elaborando}
                                            inputRef={field.ref}
                                            useGrouping={false}
                                            maxFractionDigits={0}
                                            minFractionDigits={0}
                                            max={9999999999}
                                            onChange={(e) => {
                                                clearErrors("versaoInicial")
                                                setDadosElaboracao({ ...dadosElaboracao, versaoInicial: e.value as number })
                                            }}
                                            style={{ width: '60%' }} />
                                    )} />
                                </div>
                                {errors.versaoInicial && errors.versaoInicial.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.versaoInicial?.message as string}</span> : null}
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <Label className="col col-sm-12" obrigatorio>Responsável Revisão</Label>
                                    <Controller name="responsavelRevisao" control={control} render={({ field }) => (
                                        <AutoComplete
                                            disabled={!elaborando}
                                            inputRef={field.ref}
                                            dropdown
                                            value={dadosElaboracao.responsavelRevisao}
                                            placeholder="Selecione um usuário"
                                            style={{ width: '100%' }}
                                            className={errors.cliente ? "p-invalid" : ""}
                                            field="nome"
                                            itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                                            suggestions={usuariosFiltrados}
                                            completeMethod={(e) => {
                                                let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                                                setUsuariosFiltrados(filtered);
                                            }}
                                            onChange={(e) => {


                                                let finalizarElaboracaoLocal = JSON.parse(JSON.stringify(dadosElaboracao));

                                                if (!e.target.value) {
                                                    finalizarElaboracaoLocal.responsavelRevisao = null;
                                                } else if (typeof e.target.value == "string") {
                                                    let usuario = new Usuario();
                                                    usuario.nome = e.target.value;
                                                    finalizarElaboracaoLocal.responsavelRevisao = usuario;
                                                } else {
                                                    finalizarElaboracaoLocal.responsavelRevisao = e.target.value;
                                                }
                                                clearErrors("responsavelRevisao");
                                                setDadosElaboracao(finalizarElaboracaoLocal);
                                            }}
                                        />
                                    )} />
                                    {errors.responsavelRevisao && errors.responsavelRevisao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.responsavelRevisao?.message as string}</span> : null}
                                </div>

                                <div className="col-md-6 d-flex flex-column" >
                                    <Label className="col col-sm-12">Prazo para Revisão</Label>
                                    <Controller name="prazoRevisao" control={control} render={({ field }) => (
                                        <DatePicker
                                            disabled={!elaborando}
                                            inputRef={field.ref}
                                            value={dayjs(dadosElaboracao.prazoRevisao)}
                                            onChange={value => {
                                                clearErrors("prazoRevisao")
                                                setDadosElaboracao({ ...dadosElaboracao, prazoRevisao: value?.startOf("day").toDate() || null })
                                            }}
                                        />
                                    )} />
                                    {errors.prazoRevisao && errors.prazoRevisao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.prazoRevisao?.message as string}</span> : null}
                                </div>
                            </div>

                            {documentoVersao.temAprovacao ? <div className="row mt-3">
                                <div className="col col-sm-6">
                                    <Label className="col col-sm-12" obrigatorio>Responsável Aprovação</Label>
                                    <Controller name="responsavelAprovacao" control={control} render={({ field }) => (
                                        <AutoComplete
                                            disabled={!elaborando}
                                            inputRef={field.ref}
                                            dropdown
                                            value={dadosElaboracao.responsavelAprovacao}
                                            placeholder="Selecione um usuário"
                                            style={{ width: '100%' }}
                                            className={errors.cliente ? "p-invalid" : ""}
                                            field="nome"
                                            itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                                            suggestions={usuariosFiltrados}
                                            completeMethod={(e) => {
                                                let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                                                setUsuariosFiltrados(filtered);
                                            }}
                                            onChange={(e) => {


                                                let finalizarElaboracaoLocal = JSON.parse(JSON.stringify(dadosElaboracao));

                                                if (!e.target.value) {
                                                    finalizarElaboracaoLocal.responsavelAprovacao = null;
                                                } else if (typeof e.target.value == "string") {
                                                    let usuario = new Usuario();
                                                    usuario.nome = e.target.value;
                                                    finalizarElaboracaoLocal.responsavelAprovacao = usuario;
                                                } else {
                                                    finalizarElaboracaoLocal.responsavelAprovacao = e.target.value;
                                                }
                                                clearErrors("responsavelAprovacao")
                                                setDadosElaboracao(finalizarElaboracaoLocal);
                                            }}
                                        />
                                    )} />
                                    {errors.responsavelAprovacao && errors.responsavelAprovacao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.responsavelAprovacao?.message as string}</span> : null}
                                </div>
                                <div className="col-md-6 d-flex flex-column">
                                    <Label className="col col-sm-12">Prazo para Aprovação</Label>
                                    <Controller name="prazoAprovacao" control={control} render={({ field }) => (
                                        <DatePicker
                                            disabled={!elaborando}
                                            inputRef={field.ref}
                                            value={dayjs(dadosElaboracao.prazoAprovacao)}
                                            onChange={value => {
                                                clearErrors("prazoRevisao")
                                                setDadosElaboracao({ ...dadosElaboracao, prazoAprovacao: value?.startOf("day").toDate() || null })
                                            }}
                                        />
                                    )} />
                                    {errors.dataInicio && errors.dataInicio.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataInicio?.message as string}</span> : null}
                                </div>
                            </div> : null}
                        </div>
                        <div className="col-md-6 d-flex align-items-center justify-content-center">
                            <AnexoUnicoPanel
                                novoAnexo={anexo} onChangeNovoAnexo={(e: any) => setAnexo(e)}
                                editable={elaborando}
                                arquivo={documentoVersao.arquivo} onChange={(e) => {
                                    setDocumentoVersao({ ...documentoVersao, arquivo: e })
                                }}
                                url={documentoVersao.linkDocs || ""}
                                onCreateDocumentoOnline={(url: string) => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: url });
                                }}
                                onDeleteDocumentoOnline={() => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: null });
                                }}
                                idVersao={documentoVersao.id}
                            />
                        </div>
                    </div>
                    {elaborando && <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-sm-12 d-flex justify-content-end">
                            <Button style={{ marginRight: '10px' }} label="Enviar para revisão" onClick={() => finalizarElaboracao()} />
                        </div>
                    </div>}
                </TabPanel>
                <TabPanel header="Revisão" disabled={documentoVersao.status == "EM_ELABORACAO"}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Responsável</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.usuarioResponsavel?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>
                            
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Código</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.codigoInterno} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Nome</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" obrigatorio>Versão</Label>
                                <div className="col-sm-12">
                                    <Controller name="versaoInicial" control={control} render={({ field }) => (
                                        <InputNumber value={dadosRevisao.versao}
                                            disabled={!revisando}
                                            inputRef={field.ref}
                                            useGrouping={false}
                                            maxFractionDigits={0}
                                            minFractionDigits={0}
                                            max={9999999999}
                                            onChange={(e) => {
                                                clearErrors("versaoInicial")
                                                setDadosRevisao({ ...dadosRevisao, versao: e.value as number })
                                            }}
                                            style={{ width: '60%' }} />
                                    )} />
                                </div>
                                {errors.versaoInicial && errors.versaoInicial.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.versaoInicial?.message as string}</span> : null}
                            </div>
                            {documentoVersao.observacaoParaRevisao ? <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12">Motivo para revisão</Label>
                                <div className="col-sm-12">
                                    <InputTextarea
                                        disabled
                                        value={documentoVersao.observacaoParaRevisao}
                                        style={{ width: '100%' }}
                                        rows={4}
                                    />
                                </div>
                            </div> : null}
                            {documentoVersao.motivoReprovacao ? <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12">Motivo da reprovação</Label>
                                <div className="col-sm-12">
                                    <InputTextarea
                                        disabled
                                        value={documentoVersao.motivoReprovacao}
                                        style={{ width: '100%' }}
                                        rows={4}
                                    />
                                </div>
                            </div> : null}
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12">Observação</Label>
                                <div className="col-sm-12">
                                    <InputTextarea
                                        disabled={!revisando}
                                        required
                                        value={dadosRevisao.observacao || ''}
                                        style={{ width: '100%' }}
                                        rows={4}
                                        onChange={(e) => {
                                            setDadosRevisao({ ...dadosRevisao, observacao: e.target.value })
                                            clearErrors("observacao");
                                        }}
                                    />
                                </div>
                                {errors.observacao && errors.observacao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.observacao?.message as string}</span> : null}
                            </div>
                        </div>
                        <div className="col-md-6 align-items-center justify-content-center" style={{ display: 'flex', flexDirection: 'column' }}>
                            <AnexoUnicoPanel
                                novoAnexo={anexo} onChangeNovoAnexo={(e: any) => setAnexo(e)}
                                editable={revisando}
                                arquivo={documentoVersao.arquivo} onChange={(e) => {
                                    setDocumentoVersao({ ...documentoVersao, arquivo: e })
                                }}
                                url={documentoVersao.linkDocs || ""}
                                onCreateDocumentoOnline={(url: string) => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: url });
                                }}
                                onDeleteDocumentoOnline={() => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: null });
                                }}
                                idVersao={documentoVersao.id}
                            />
                            {dadosRevisao.versaoVigente ? <div style={{
                                marginTop: 8,
                                border: '1px solid #dadada', display: "flex", flexDirection: "column",
                                borderRadius: 4, boxSizing: "border-box", width: "90%", alignItems: "center", justifyContent: "center"
                            }}
                            >
                                <Label>Versão vigente</Label>
                                <div style={{ marginTop: 8, flexDirection: 'row', display: 'flex', alignItems: 'center', width: "60%", borderRadius: 10, border: '1px solid #dadada' }}>

                                    <FontAwesomeIcon icon="file-pdf" size={"2x"} style={{ padding: 10, borderRight: '1px solid #dadada' }} />
                                    <span style={{ padding: 10 }}>
                                        {dadosRevisao.versaoVigente.arquivo?.nome || ""}
                                    </span>

                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', width: "60%", columnGap: 8, marginTop: 8, marginBottom: 8 }}>
                                    <Button label="Baixar" className="p-button-outlined" icon="pi pi-download" style={{ display: "flex", flex: 1, boxSizing: "border-box" }} onClick={() => {
                                        fetch(dadosRevisao.versaoVigente?.arquivo?.url || "")
                                            .then(res => res.blob())
                                            .then(blob => saveAs(blob, dadosRevisao.versaoVigente?.arquivo?.nome || "arquivo"))
                                            .catch(e => {
                                                console.error(e)
                                            });
                                        return false;
                                    }} />
                                    <Button
                                        label="Ver" className="p-button-outlined" icon="pi pi-eye"
                                        style={{ display: "flex", flex: 1, boxSizing: "border-box" }}
                                        onClick={() => { setDocumentoVisualizar({ visible: true, arquivo: dadosRevisao.versaoVigente?.arquivo as Arquivo }) }}
                                    />
                                </div>
                            </div> : null}
                        </div>
                    </div>
                    {revisando && <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-sm-12 d-flex justify-content-end">
                            <Button style={{ marginRight: '10px' }} label="Finalizar revisão" onClick={() => finalizarRevisao()} />
                        </div>
                    </div>}
                </TabPanel>
                {documentoVersao.temAprovacao ? <TabPanel header="Aprovação" disabled={documentoVersao.status == "EM_ELABORACAO" || documentoVersao.status == "EM_REVISAO"} >
                    <div className="row">
                        <div className="col-md-6">
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Responsável</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.usuarioResponsavel?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>

                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Código</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.codigoInterno} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Nome</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" obrigatorio>Versão</Label>
                                <div className="col-sm-12">
                                    <InputNumber value={dadosRevisao.versao}
                                        disabled={!aprovando}
                                        useGrouping={false}
                                        maxFractionDigits={0}
                                        minFractionDigits={0}
                                        max={9999999999}
                                        style={{ width: '60%' }}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12">Observação</Label>
                                <div className="col-sm-12">
                                    <InputTextarea
                                        required
                                        disabled={!aprovando}
                                        value={dadosAprovacao.observacao || ''}
                                        style={{ width: '100%' }}
                                        rows={4}
                                        onChange={(e) => {
                                            setDadosAprovacao({ ...dadosAprovacao, observacao: e.target.value })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 d-flex align-items-center justify-content-center">
                            <AnexoUnicoPanel
                                novoAnexo={anexo} onChangeNovoAnexo={(e: any) => setAnexo(e)}
                                editable={false}
                                arquivo={documentoVersao.arquivo} onChange={(e) => {
                                    setDocumentoVersao({ ...documentoVersao, arquivo: e })
                                }}
                                url={documentoVersao.linkDocs || ""}
                                onCreateDocumentoOnline={(url: string) => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: url });
                                }}
                                onDeleteDocumentoOnline={() => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: null });
                                }}
                                idVersao={documentoVersao.id}
                            />
                        </div>
                    </div>
                    {aprovando && <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-sm-12 d-flex justify-content-end">
                            <Button className="p-button-danger" style={{ marginRight: '10px' }} label="Reprovar" onClick={() => setVisibleModalDocumentoReprovar(true)} />
                            <Button className="p-button-success" style={{ marginRight: '10px' }} label="Aprovar" onClick={() => finalizarAprovacao(true)} />
                        </div>
                    </div>}
                </TabPanel> : null}
                <TabPanel header="Publicação" disabled={elaborando || revisando || aprovando}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Responsável</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.usuarioResponsavel?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>

                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Código</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.codigoInterno} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Nome</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>

                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Validade</Label>
                                <Controller name="validade" control={control} render={({ field }) => (
                                    <DatePicker
                                        disabled={!publicando}
                                        inputRef={field.ref}
                                        value={dayjs(dadosPublicarVersao.validade)}
                                        onChange={value => {
                                            clearErrors("validade")
                                            setDadosPublicarVersao({ ...dadosPublicarVersao, validade: value?.startOf("day").toDate() || null })
                                        }}
                                    />
                                )} />
                                {errors.validade && errors.validade.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.validade?.message as string}</span> : null}
                            </div>

                            <div className="row align-items-end">
                                <div className="col-md-6">
                                    <Label>Interessados</Label>
                                    <InputText
                                        value={dadosPublicarVersao.interessados.map(u => u.usuario?.nome).join(", ")}
                                        readOnly
                                        style={{ width: '100%' }}
                                    />
                                    {errors.responsavelRevisao && errors.responsavelRevisao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.responsavelRevisao?.message as string}</span> : null}
                                </div>

                                <div className="col-md-6 d-flex align-items-end">
                                    <Button disabled={!publicando} style={{ marginRight: '5px' }} icon={<FontAwesomeIcon icon="edit" />} onClick={() => setVisibleInteressados(true)} />
                                </div>
                            </div>

                            <div className="row align-items-end">
                                <div className="col-md-6">
                                    <Label>Confirmação de Leitura</Label>
                                    <InputText
                                        value={dadosPublicarVersao.necessidadesConfirmacao.map(u => u.usuario?.nome).join(", ")}
                                        readOnly
                                        style={{ width: '100%' }}
                                    />
                                </div>

                                <div className="col-auto d-flex align-items-end">
                                    <Button disabled={!publicando} style={{ marginRight: '2px' }} icon={<FontAwesomeIcon icon="edit" />} onClick={() => setVisibleLeitores(true)} />
                                </div>
                                <div className="col-auto d-flex flex-column">
                                    <Label>Dias</Label>
                                    <InputNumber disabled={!publicando} value={dadosPublicarVersao.diasConfirmacaoLeitura} onChange={(e) => setDadosPublicarVersao({ ...dadosPublicarVersao, diasConfirmacaoLeitura: e.value })}
                                        locale='pt-BR' useGrouping={false}
                                    />
                                </div>
                            </div>
                        </div>
                        {errors.responsavelRevisao && errors.responsavelRevisao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.responsavelRevisao?.message as string}</span> : null}
                        <div className="col-md-6 d-flex align-items-center justify-content-center">
                            <AnexoUnicoPanel
                                novoAnexo={anexo} onChangeNovoAnexo={(e: any) => setAnexo(e)}
                                arquivo={documentoVersao.arquivo} onChange={(e) => {
                                    setDocumentoVersao({ ...documentoVersao, arquivo: e })
                                }}
                                url={documentoVersao.linkDocs || ""}
                                onCreateDocumentoOnline={(url: string) => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: url });
                                }}
                                onDeleteDocumentoOnline={() => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: null });
                                }}
                                idVersao={documentoVersao.id}
                            />
                        </div>
                    </div>
                    {publicando && <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-sm-12 d-flex justify-content-end">
                            <Button style={{ marginRight: '10px' }} label="Publicar" onClick={() => publicar()} />
                        </div>
                    </div>}
                </TabPanel>
                <TabPanel header="Publicado" disabled={documentoVersao.status !== "PUBLICADO"}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Responsável</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.usuarioResponsavel?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>

                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Código</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.codigoInterno} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Nome</Label>
                                <div className="col-sm-12">
                                    <InputText value={documentoVersao.documento?.nome} style={{ width: '60%' }} />
                                </div>
                            </div>
                            <div className="row" style={{ marginLeft: '-2px' }}>
                                <Label className="col col-sm-12" >Data da Publicação</Label>
                                <div className="col-sm-12">
                                    <InputText value={converterDataHora(documentoVersao.dataPublicacao)} style={{ width: '60%' }} />
                                </div>
                                {errors.dataInicio && errors.dataInicio.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataInicio?.message as string}</span> : null}
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <DataTable emptyMessage="Nenhum resultado encontrado" value={documentoVersao.confirmacaoLeitura} header='Confirmação de Leitura'>
                                        <Column field="usuario.nome" header="Usuario" />
                                        <Column field="data" header="Data" body={(rowData) => converterDataHora(rowData.data)} />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                        {errors.responsavelRevisao && errors.responsavelRevisao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.responsavelRevisao?.message as string}</span> : null}
                        <div className="col-md-6 d-flex align-items-center justify-content-center">
                            <AnexoUnicoPanel
                                novoAnexo={anexo} onChangeNovoAnexo={(e: any) => setAnexo(e)}
                                arquivo={documentoVersao.arquivo} onChange={(e) => {
                                    setDocumentoVersao({ ...documentoVersao, arquivo: e })
                                }}
                                url={documentoVersao.linkDocs || ""}
                                onCreateDocumentoOnline={(url: string) => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: url });
                                }}
                                onDeleteDocumentoOnline={() => {
                                    setDocumentoVersao({ ...documentoVersao, linkDocs: null });
                                }}
                                idVersao={documentoVersao.id}
                            />
                        </div>
                    </div>
                </TabPanel>
            </TabView>

        </BaseCadastro >
    )
}
